import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Loader2, Shield } from 'lucide-react';

/* ========== TRANSFER OWNERSHIP MODAL ========== */
export const TransferOwnershipModal = ({ userData, onClose, onConfirm, loading }) => {
  const [confirmText, setConfirmText] = useState('');
  const canTransfer = confirmText.toLowerCase() === 'transfer';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose} data-testid="transfer-ownership-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="p-5 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center">
              <Shield className="w-5 h-5 text-purple-600" />
            </div>
            <div>
              <h3 className="font-outfit font-semibold text-slate-900">Transfer Ownership</h3>
              <p className="text-sm text-slate-500">This will make you an admin</p>
            </div>
          </div>
        </div>

        <div className="p-5 space-y-4">
          <div className="bg-purple-50 rounded-xl p-4 border border-purple-100">
            <p className="text-sm text-purple-800">
              You are about to transfer platform ownership to <strong>{userData.name || userData.email}</strong> ({userData.email}).
            </p>
            <ul className="text-sm text-purple-700 mt-2 space-y-1">
              <li>They will become the new <strong>Owner</strong></li>
              <li>Your role will be demoted to <strong>Admin</strong></li>
              <li>Only the new Owner can transfer ownership back</li>
            </ul>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              Type <span className="font-mono bg-slate-100 px-1.5 py-0.5 rounded text-purple-600">transfer</span> to confirm
            </label>
            <Input
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type 'transfer' to confirm"
              className="border-purple-200 focus:ring-purple-500/20"
              data-testid="transfer-confirm-input"
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 p-5 border-t border-slate-100 bg-slate-50/50">
          <Button variant="outline" onClick={onClose} data-testid="transfer-cancel-btn">Cancel</Button>
          <Button
            onClick={onConfirm}
            disabled={!canTransfer || loading}
            className="bg-purple-600 hover:bg-purple-700 text-white disabled:opacity-50"
            data-testid="transfer-confirm-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Shield className="w-4 h-4 mr-2" />}
            Transfer Ownership
          </Button>
        </div>
      </div>
    </div>
  );
};
